import React from "react";

export default ({ image, className="" }) => <img alt={image.alt} className={`${className} lazyload`} src={image.src} data-srcset={image.srcset} />